import { DatePipe, JsonPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from '../api-service.service';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';

@Component({
  selector: 'app-ais140-tml-api-logs',
  templateUrl: './ais140-tml-api-logs.component.html',
  styleUrls: ['./ais140-tml-api-logs.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    JsonPipe,
    DatePipe,
    MatIcon,
    MatTooltip,
    CommonSearchComponent,
    CommonPaginationComponent,
  ],
})
export class AIS140TmlApiLogsComponent implements OnInit {
  size = 10;
  page = 1;
  listOfBatch = [];
  totalLength = 0;
  ticketStatusUpdateLogsForm: FormGroup = this.formBuilder.group({});
  userPermission = [];
  search = '';
  ticketStatus = [
    {
      statusCode: 'STS_CO_01',
      status: 'Not Assigned',
    },
    {
      statusCode: 'STS_CO_02',
      status: 'Assigned',
    },
    {
      statusCode: 'STS_CO_03',
      status: 'Started',
    },
    {
      statusCode: 'STS_CO_04',
      status: 'In Queue',
    },
    {
      statusCode: 'STS_CO_05',
      status: 'In Progress',
    },
    {
      statusCode: 'STS_CO_06',
      status: 'Completed',
    },
    {
      statusCode: 'STS_CO_07',
      status: 'On Hold Due to Vehicle Not Available',
    },
    {
      statusCode: 'STS_CO_08',
      status: 'On Hold Due to Ignition Not ON',
    },
    {
      statusCode: 'STS_CO_09',
      status: 'On Hold Due to GSM Network Not Available',
    },
    {
      statusCode: 'STS_CO_10',
      status: 'On Hold Due to Invalid GPS',
    },
    {
      statusCode: 'STS_CO_11',
      status: 'On Hold Due To Vahan Portal Down',
    },
    {
      statusCode: 'STS_CO_12',
      status: 'On Hold Due to Data not Available on VAHAN',
    },
    {
      statusCode: 'STS_CO_13',
      status: 'On Hold Due to Backend Portal Down',
    },
    {
      statusCode: 'STS_CO_14',
      status: 'On Hold Due to Panic Event Not Confirmed',
    },
    {
      statusCode: 'STS_CO_15',
      status: 'On Hold Due to OTP not being received',
    },
    {
      statusCode: 'STS_CO_16',
      status: 'On Hold Due to Live Location Pending from Backend',
    },
    {
      statusCode: 'STS_CO_17',
      status: 'On Hold Due to Waiting for RTO Approval',
    },
    {
      statusCode: 'STS_CO_18',
      status: 'Ticket Completed and Closed',
    },
    {
      statusCode: 'STS_CO_19',
      status: 'Ticket Generated but Data Not Received from CRM',
    },
    {
      statusCode: 'STS_CO_20',
      status: 'Ticket Cancelled Due to Change Request Device Change',
    },
    {
      statusCode: 'STS_CO_21',
      status: 'Ticket Cancelled Due to Change Request Vehicle Owner Change',
    },
    {
      statusCode: 'STS_CO_22',
      status: 'Ticket Cancelled Due to Change Request RTO or State Change',
    },
    {
      statusCode: 'STS_CO_23',
      status: 'Ticket Cancelled as per Request',
    },
    {
      statusCode: 'STS_CO_24',
      status: 'Ticket Cancelled Due to Invoice Cancelled',
    },
    {
      statusCode: 'STS_CO_25',
      status: 'Change required from CRM',
    },
    {
      statusCode: 'STS_CO_26',
      status: 'Other',
    },
    {
      statusCode: 'STS_CO_27',
      status: 'FE has not Initiated the Process',
    },
    {
      statusCode: 'STS_CO_28',
      status: 'On Hold Due to Non-Working Hours',
    },
    {
      statusCode: 'STS_CO_29',
      status: 'On Hold Due to SIM Validity Issue',
    },
    {
      statusCode: 'STS_CO_30',
      status: 'Ticket Suspended Due to Customer Not Responding',
    },
    {
      statusCode: 'STS_CO_31',
      status: 'On Hold Due to No Response from Customer',
    },
    {
      statusCode: 'STS_CO_32',
      status: 'On Hold Due to Customer Details Mismatch',
    },
  ];
  ticketStatusUpdateLogView = false;

  constructor(
    public apiMicroservice: ApiServiceService,
    private formBuilder: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.setTicketStatusUpdateLogForm();
    this.checkPermission();
    if (this.ticketStatusUpdateLogView) {
      this.fetchApiLogList();
    }
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (
          element.pageName === 'AIS140 Ticket Status Update Logs' &&
          element.view === false
        ) {
          this.navigateBack();
        } else if (
          element.pageName === 'AIS140 Ticket Status Update Logs' &&
          element.view === true
        ) {
          this.ticketStatusUpdateLogView = true;
        }
      }
    );
  }

  setTicketStatusUpdateLogForm() {
    this.ticketStatusUpdateLogsForm = this.formBuilder.group({
      batchListSearch: new FormControl(''),
    });
  }

  fetchApiLogList() {
    this.spinner.show();
    this.listOfBatch = [];
    this.apiMicroservice
      .getApiLogsData(this.page, this.size, this.search)
      .subscribe((res) => {
        if (res.status) {
          this.listOfBatch = res.data.data;
          if (this.listOfBatch.length > 0) {
            this.listOfBatch.map((data) => {
              if (data.endpoint === 'webhook') {
                data.request_body.Ticket_Status = this.ticketStatus.find(
                  (status) =>
                    status.statusCode === data.request_body.Ticket_Status
                )?.status;
              }
              if (data.endpoint === 'esbPayload') {
                data.request_body.TM_Ticket_Status = this.ticketStatus.find(
                  (status) =>
                    status.statusCode === data.request_body.TM_Ticket_Status
                )?.status;
              }
            });
          }
          this.totalLength = res.data.totalItems;
          this.apiMicroservice.openSnackbar(res.message);
          this.spinner.hide();
        } else {
          this.apiMicroservice.openSnackbar('Data not Found');
          this.spinner.hide();
        }
      });
  }

  onPageChange(event: number) {
    this.page = event;
    this.listOfBatch = [];
    this.fetchApiLogList();
  }

  onSizeChange(event: number) {
    this.page = 1;
    this.size = event;
    this.fetchApiLogList();
  }

  onSearch(event: string) {
    this.page = 1;
    this.search = event;
    this.ticketStatusUpdateLogsForm
      ?.get('batchListSearch')
      ?.setValue(this.search ? this.search : '');
    this.fetchApiLogList();
  }

  navigateBack() {
    this.apiMicroservice.back();
  }
}
